import React, {useState} from "react";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {push} from "react-router-redux";
import setTitle from "utils/set_title";
import DataAssetsCreateView from "../components/data_assets_create_view";
import getWorkflowInstances from "modules/flowmaster/actions/workflow_instances_fetch";
import requestor from "requestor";

function DataAssetsCreateViewContainer(props) {
  const [loadingConfigs, setLoadingConfigs] = useState(false);
  const [fetchConfigsError, setFetchConfigsError] = useState<string | null>(
    null,
  );

  async function fetchDefinitionConfigs() {
    const {organisationId, definitionId} = props.params;

    setFetchConfigsError(null);
    setLoadingConfigs(true);

    try {
      await props.fetchDefinitionConfigs(organisationId, definitionId);
    } catch (error) {
      setFetchConfigsError("Failed to load configurations");
    } finally {
      setLoadingConfigs(false);
    }
  }

  setTitle("Data Assets Create/View");
  return (
    <DataAssetsCreateView
      {...props}
      fetchDefinitionConfigs={fetchDefinitionConfigs}
      isLoadingConfigs={loadingConfigs}
      fetchConfigsError={fetchConfigsError}
    />
  );
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        fetchDefinitionConfigs: getWorkflowInstances(requestor),
        push,
      },
      dispatch,
    ),
  };
}

function select(state) {
  return {
    organisation: state.organisation,
    user: state.user,
    definitions: state.workflows,
  };
}

export default connect(
  select,
  mapDispatchToProps,
)(DataAssetsCreateViewContainer);
